import { logger } from "../../shared/utils/logger.client";

export type AuthConfig = {
  // MYGOV
  clientId: string;
  authorizeEndpoint: string;
  tokenEndpoint: string;
  redirectEndpoint: string;
  scope?: string;

  // EIDAS
  clientIdEidas?: string;
  authorizeEndpointEidas?: string;
  tokenEndpointEidas?: string;
  redirectEndpointEidas?: string;
  userInfoEndpointEidas?: string;
  tokenAuthMethodEidas?: "client_secret_basic" | "client_secret_post" | "private_key_jwt" | "none";

  // flags
  skipMyGovAuth?: boolean;
  eidasEnabled?: boolean;
};

let config: AuthConfig | null = null;

export const fetchAuthConfig = async (): Promise<AuthConfig> => {
  if (config) return config;

  const res = await fetch("/env");
  if (!res.ok) throw new Error("Failed to load auth config");

  const data = await res.json();
  config = {
    clientId: data.clientId,
    authorizeEndpoint: data.authorizeEndpoint,
    tokenEndpoint: data.tokenEndpoint,
    redirectEndpoint: data.redirectEndpoint,

    clientIdEidas: data.eidasClientId,
    authorizeEndpointEidas: data.eidasAuthorizeEndpoint,
    tokenEndpointEidas: data.eidasTokenEndpoint,
    redirectEndpointEidas: data.eidasRedirectEndpoint,
    userInfoEndpointEidas: data.eidasUserInfoEndpoint,
    tokenAuthMethodEidas: data.eidasTokenAuthMethod,

    skipMyGovAuth: data.skipMyGovAuth === true || data.skipMyGovAuth === "true",
    eidasEnabled: data.eidasEnabled === true || data.eidasEnabled === "true" || false,
  };
  return config;
};

export const isMyGovSkipEnabled = async (): Promise<boolean> => {
  const cfg = await fetchAuthConfig();

  logger.debug("Auth config fetched:", cfg);
  logger.debug("skipMyGovAuth value from env:", cfg.skipMyGovAuth);

  return cfg.skipMyGovAuth === true;
};

export const isEidasEnabled = async (): Promise<boolean> => {
  const cfg = await fetchAuthConfig();
  return cfg.eidasEnabled === true;
};
